module.exports = "mat-form-field {\n  width: 100%;\n}\nmat-option mat-icon {\n  margin-right: 0;\n  vertical-align: middle;\n  margin-top: -2px;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./Angular/app/projects/edit-particulars/edit-particulars.component.less
// module id = ./Angular/app/projects/edit-particulars/edit-particulars.component.less
// module chunks = main